import Modal from "components/atoms/modal";
import { TextSm } from "components/atoms/text";
import Btn from "components/atoms/buttons";
import SignUpSuccess from "types/SignUpSuccess";

interface Props {
  onClick: () => void;
  signUpSuccess?: SignUpSuccess;
}

const ModalWelcome = ({ onClick, signUpSuccess }: Props) => {
  const isCompamy = signUpSuccess?.type === "company";

  return (
    <Modal.Container className="min-w-[312px] p-10 rounded-16 text-center">
      <TextSm className="text-black-100% mb-5 whitespace-pre-wrap">
        {isCompamy ? (
          <>
            마코디 가입을 진심으로 환영합니다.
            <br />
            전문가회원은 승인문자 받으시고 로그인하세요.
            <br />
            <span className="text-xs text-black-60%">
              (영업일 기준 1~2일 이내)
            </span>
          </>
        ) : (
          "마코디 가입을 진심으로 환영합니다.\n샘플신청과 제품가격은 전문가회원에게만 \n제공됩니다."
        )}
      </TextSm>
      <Btn.Blue onClick={onClick} size="large" className="w-full">
        확인
      </Btn.Blue>
    </Modal.Container>
  );
};

export default ModalWelcome;
